module.exports = __webpack_public_path__ + "static/media/2_duplex_B_BW_square.91af5cc2.png";